import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02617951"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = {
  class: "page_title_bar flex_FSBC"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "page_title_bar_name"
}, "隐私政策管理", -1));
const _hoisted_4 = {
  class: "container"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label"
}, "用户协议", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label"
}, "隐私政策", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ArrowRight = _resolveComponent("ArrowRight");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
    size: "5vw",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back(-1))
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowLeft, {
      color: "#fff"
    })]),
    _: 1
  }), _hoisted_3, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowLeft, {
      color: "#00000000"
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "box flex_FSBC",
    onClick: _cache[1] || (_cache[1] = () => $setup.toTargetPage('/protocol', 'https://tianchenhulian.com/protocol/index.html?keyword=UPN driver'))
  }, [_hoisted_5, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })]), _createElementVNode("div", {
    class: "box flex_FSBC",
    onClick: _cache[2] || (_cache[2] = () => $setup.toTargetPage('/protocol', 'https://tianchenhulian.com/protocol/index.html?keyword=PP driver'))
  }, [_hoisted_6, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })])])]);
}